const InvalidContactInfoMessage = 'invalid_contact_info';
export default class InvalidContactInfoError extends Error {
    constructor(message: string) {
        super(`${InvalidContactInfoMessage}: ${message}`);
    }
}
